import { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0
      },
      html: {
        // '-webkit-font-smoothing': 'antialiased',
        // '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
        fontSize: '16px'
      },
      body: {
        height: '100%',
        width: '100%',
        scrollbarWidth: 'none',
        scrollbarHeight: 'none',
        '&::-webkit-scrollbar': {
          display: 'none'
        }
      },
      '#root': {
        height: '100%',
        width: '100%'
      }
    }
  })
);

const GlobalStyles: FC = () => {
  useStyles();

  return null;
};

export default GlobalStyles;

export const GlobalStylesHTML = () => `
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    .liquid {
      display: none;
    }
  `;
